import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import ResponsiveModal from '../ui/Modal/ResponsiveModal';
import { apiService } from '../../services/api';

interface SendSMSModalProps {
  isOpen: boolean;
  onClose: () => void;
  customerId: string;
  customerName: string;
  customerPhone: string;
}

const SendSMSModal: React.FC<SendSMSModalProps> = ({
  isOpen,
  onClose,
  customerId,
  customerName,
  customerPhone,
}) => {
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  const handleSend = async () => {
    if (!message.trim()) return;
    setSending(true);
    try {
      await apiService.post(`/messaging/customers/${customerId}/send-sms`, { message });
      toast.success(`SMS sent to ${customerName}`);
      setMessage('');
      onClose();
    } catch (error: any) {
      toast.error(error?.detail || error?.message || 'Failed to send SMS');
    } finally {
      setSending(false);
    }
  };

  return (
    <ResponsiveModal
      isOpen={isOpen}
      onClose={onClose}
      title={`Send SMS to ${customerName}`}
      size="sm"
    >
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">To</label>
          <p className="text-sm text-gray-600">{customerPhone}</p>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Message <span className="text-gray-400">({message.length}/160)</span>
          </label>
          <textarea
            autoFocus
            rows={4}
            maxLength={160}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Type your message..."
          />
        </div>
        <div className="flex justify-end gap-3 pt-2">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            disabled={!message.trim() || sending}
            onClick={handleSend}
            className="px-4 py-2 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 disabled:opacity-50"
          >
            {sending ? 'Sending...' : 'Send SMS'}
          </button>
        </div>
      </div>
    </ResponsiveModal>
  );
};

export default SendSMSModal;
